import { createElement } from 'react';
import { ItemProps } from './.';
import { BaseItem } from './__internal__/BaseItem';
import './Item.css';

/**
 * The 'standard' item is a list item providing the most common use
 * cases, e.g. icon, title, description, info, and counter.
 *
 * <b>Note:</b> The Item is meant to use either a ListProps' `renderItem`
 * or ListColumnProps' `item`, which will display at the body of
 * the item.
 *
 * @component
 * @param {ItemProps} props the ItemProps properties
 * @returns the Item element
 */
export const Item = (props: ItemProps) => {
  return <BaseItem {...props} />;
};
